import { Button, Space } from "antd";
import {
  EyeOutlined,
  DeleteOutlined,
  DollarOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import React from "react";
import { TableColumns, TableProperties } from "../../../../shared/components/ui/Table/types";
import { ProgramScheduleType } from "../../../../types/dto/program";
import Table from "../../../../shared/components/ui/Table";
import { programPaymentScheduleAcademy } from "../../../../shared/services";
import useDeletePayments from "../../hooks/payments/useDeletePayments";
import { ModalPaymentProgramStuden } from "../../../../shared/components/ui/modals/ModalPaymentProgramStuden";
import { ModalEditProgramsSchedule } from "../../../../shared/components/ui/modals/ModalEditProgramsSchedule";
import { ModalBulkEditProgramsSchedule } from "../../../../shared/components/ui/modals/ModalBulkEditProgramsSchedule";
import { useNavigate } from "react-router-dom";
import { formatNumberPrice } from "../../../../shared/utils/Helper";
import { formatScheduleMonth } from "../../utils/scheduleDateUtils";

interface TableProgramProps {
  program_id: number;
  onAddSchedule?: () => void;
}

export const TableProgramPayments = ({
  program_id,
  onAddSchedule,
}: TableProgramProps) => {
  const [openModalPaymentProgramStudent, setModalPaymentProgramStudent] =
    React.useState<boolean>(false);
  const [openModalEditProgramsSchedule, setOpenModalEditProgramsSchedule] =
    React.useState<boolean>(false);
  const [openModalBulkEditProgramsSchedule, setOpenModalBulkEditProgramsSchedule] =
    React.useState<boolean>(false);

  const [scheduleId, setScheduleId] = React.useState<number | null>(null);
  const [minAmount, setMinAmount] = React.useState<number>();
  const [selectedSchedule, setSelectedSchedule] =
    React.useState<ProgramScheduleType>();
  const [selectedSchedules, setSelectedSchedules] = React.useState<
    ProgramScheduleType[]
  >([]);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
  const [tableInstance, setTableInstance] =
    React.useState<TableProperties>();

  const { showDeleteConfirm } = useDeletePayments();

  const handleModaCreatePayment = (scheduleId: number, minAmount: number) => {
    setScheduleId(scheduleId);
    setMinAmount(minAmount)
    setModalPaymentProgramStudent(true);
  };
  const navigate = useNavigate();

  const hanldeRedirectPersonalInfo = (schedule_id: number, program_id: number) => {
    navigate(`/gestion-academy/student-schedule/${schedule_id}/${program_id}`);
  };

  const handleOpenEditModal = (schedule: ProgramScheduleType) => {
    setSelectedSchedule(schedule);
    setOpenModalEditProgramsSchedule(true);
  };

  const handleBulkEditSuccess = () => {
    setSelectedRowKeys([]);
    setSelectedSchedules([]);
    tableInstance?.refresh();
  };

  const handleOpenBulkEditModal = () => {
    if (!selectedSchedules.length) return;
    setOpenModalBulkEditProgramsSchedule(true);
  };

  const fetchQueryProps = React.useMemo(
    () => ({
      program_id,
    }),
    [program_id]
  );

  const resolveScheduleId = (key: React.Key) => {
    if (typeof key === "number") return key;
    const numericKey = Number(key);
    if (!Number.isNaN(numericKey)) return numericKey;
    const match = String(key).match(/(\d+)$/);
    return match ? Number(match[1]) : NaN;
  };

  const handleRowSelectionChange = (
    keys: React.Key[],
    rows: ProgramScheduleType[]
  ) => {
    setSelectedRowKeys(keys);
    setSelectedSchedules((prev) => {
      const scheduleMap = new Map(prev.map((schedule) => [schedule.id, schedule]));

      rows.forEach((row) => scheduleMap.set(row.id, row));

      return keys
        .map((key) => scheduleMap.get(resolveScheduleId(key)))
        .filter((schedule): schedule is ProgramScheduleType => !!schedule);
    });
  };

  const columns: TableColumns<ProgramScheduleType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: "Mes de cobro",
      dataIndex: "month",
      key: "month",
      width: 140,
      render: (_, item: ProgramScheduleType) => (
        <span className="capitalize">
          {formatScheduleMonth(item.month, item.day_of_month_payment_limit)}
        </span>
      ),
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: "ascend",
    },
    {
      title: "Fecha limite de pago",
      dataIndex: "day_of_month_payment_limit",
      key: "day_of_month_payment_limit",
      width: 160,
      render: (_, item: ProgramScheduleType) => (
        <span className="capitalize">
          {moment(item.day_of_month_payment_limit).format("YYYY/MM/DD")}
        </span>
      ),
    },
    {
      title: "Monto",
      key: "price",
      width: 130,
      render: (_, item: ProgramScheduleType) => (
        <span>{formatNumberPrice(+item.price)}</span>
      ),
    },
    {
      title: "Monto pronto pago",
      key: "price_with_prompt_payment_discount",
      width: 160,
      render: (_, item: ProgramScheduleType) => (
        <span>{formatNumberPrice(+item.price_with_prompt_payment_discount)}</span>
      ),
    },
    {
      title: "Acciones",
      key: "operation",
      width: 220,
      fixed: "right",
      render: (_, item: ProgramScheduleType) => (
        <Space size="small">
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            size="large"
            onClick={() => handleOpenEditModal(item)}
          />
          <Button
            type="primary"
            shape="circle"
            icon={<EyeOutlined />}
            size="large"
            onClick={() => hanldeRedirectPersonalInfo(item.id, item.program_id)}
          />
          <Button
            type="primary"
            shape="circle"
            icon={<DollarOutlined />}
            size="large"
            onClick={() =>
              handleModaCreatePayment(
                item.id,
                +item.price_with_prompt_payment_discount
              )
            }
          />
          <Button
            type="primary"
            shape="circle"
            danger
            onClick={() => {
              showDeleteConfirm(item.id, "");
            }}
            icon={<DeleteOutlined />}
            size="large"
          />
        </Space>
      ),
    },
  ];

 
  return (
    <>
      <ModalPaymentProgramStuden
        openModal={openModalPaymentProgramStudent}
        setOpenModal={setModalPaymentProgramStudent}
        program_id={program_id}
        scheduleId={scheduleId!}
        minAmount={minAmount!}
      />
      <ModalEditProgramsSchedule
        openModal={openModalEditProgramsSchedule}
        setOpenModal={setOpenModalEditProgramsSchedule}
        programSchedule={selectedSchedule}
        onSuccess={() => tableInstance?.refresh()}
      />
      <ModalBulkEditProgramsSchedule
        openModal={openModalBulkEditProgramsSchedule}
        setOpenModal={setOpenModalBulkEditProgramsSchedule}
        programSchedules={selectedSchedules}
        onSuccess={handleBulkEditSuccess}
      />
      <div className="mb-3 flex flex-wrap items-center justify-end gap-2">
        <Button
          type="default"
          shape="round"
          icon={<EditOutlined />}
          size="large"
          disabled={!selectedSchedules.length}
          onClick={handleOpenBulkEditModal}
        >
          Editar montos seleccionados
          {selectedSchedules.length > 0
            ? ` (${selectedSchedules.length})`
            : ""}
        </Button>
        {onAddSchedule ? (
          <Button
            type="primary"
            shape="round"
            icon={<PlusOutlined />}
            size="large"
            onClick={onAddSchedule}
          >
            Agregar cronograma de pagos
          </Button>
        ) : null}
      </div>
      <Table<ProgramScheduleType>
        columns={columns}
        fetchQueryProps={fetchQueryProps}
        onLoad={setTableInstance}
        rowKey="id"
        rowSelection={{
          selectedRowKeys,
          preserveSelectedRowKeys: true,
          columnWidth: 48,
          onChange: handleRowSelectionChange,
        }}
        scroll={{ x: 1100 }}
        service={programPaymentScheduleAcademy}
      />
    </>
  );
};
